import './../app/shared/operators';
import { of } from 'rxjs/observable/of';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as u from '../actions/user.actions';

import { Api } from '../providers/api/api';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers'
import 'rxjs/add/operator/concatMap'


@Injectable()
export class FilterEffects {
  constructor(private actions$: Actions,
    private api: Api,
    private store: Store<fromRoot.State>
  ) {
  }

  @Effect()
  addStockToFilter$: Observable<Action> = this.actions$
    .ofType(u.ADD_STOCK_TO_FILTER)
    .map((action: u.AddStockToFilter) => {
      return action.payload;
    })
    .switchMap((payload) => {
      return this.api.addStockToFilter(payload.user, payload.filter, payload.company);
    })
    .map(filters => {
      return new u.FetchFiltersSuccess(filters);
    }).catch((err) => of(new u.AddStockToFilterFailure(err)));


  @Effect()
  fetchFilters$: Observable<Action> = this.actions$
    .ofType(u.FETCH_FILTERS)
    .map((action: u.FetchFilters) => {
      return action.payload;
    })
    .switchMap((payload) => this.api.fetchFilters(payload))
    .map(filters => {
      return new u.FetchFiltersSuccess(filters);
    }).catch((err) => of(new u.FetchFiltersFailure(err)));


  @Effect()
  craeteFilters$: Observable<Action> = this.actions$
    .ofType(u.CREATE_FILTER)
    .map((action: u.CreateFilter) => {
      return action.payload;
    })
    .switchMap((payload) => {
      return this.api.createFilter(payload);
    })
    .map(filters => {
      return new u.CreateFilterSuccess(filters);
    }).catch((err) => of(new u.CreateFilterFailure(err)));


  @Effect()
  updateFilter$: Observable<Action> = this.actions$
    .ofType(u.UPDATE_FILTER)
    .map((action: u.UpdateFilter) => {
      return action.payload;
    })
    .withLatestFrom(this.store)
    .concatMap(([payload, storeState]) => {
      return this.api.updateFilter(storeState.user._id, payload.filter);
    })
    .map(filters => {
      return new u.UpdateFilterSuccess(filters);
    }).catch((err) => of(new u.UpdateFilterFailure(err)));


  @Effect()
  deleteFilters$: Observable<Action> = this.actions$
    .ofType(u.DELETE_FILTER)
    .map((action: u.DeleteFilter) => {
      return action.payload;
    })
    .switchMap((payload) => {
      return this.api.deleteFilter(payload.user_id, payload.filter);
    })
    .map(filters => {
      return new u.FetchFiltersSuccess(filters);
    }).catch((err) => of(new u.FetchFiltersFailure(err)));


}



// WEBPACK FOOTER //
// ./src/effects/filter.effects.ts